//特定の位置に達したらclassを付与
function io() {
	const targets = document.querySelectorAll('.lower__heading');
	if (targets.length === 0) return; // 対象が無いページでは何もしない

	const pageLink = document.querySelector('.pageLink');
	const wrapper = document.querySelector('.scFix');
	const header = document.querySelector('.header');
	const caseLinkTop = document.querySelector('.caseLinkTop');

	if (!pageLink || !wrapper || !header) return; // 関連要素が揃っていないページでも止める

	let observer = null;
	let isFixed = false;

	function createObserver() {
		if (observer) observer.disconnect();

		const headerHeight = header.offsetHeight;

		const options = {
			rootMargin: `-${headerHeight}px 0px 0px 0px`,
			threshold: 0
		};

		observer = new IntersectionObserver(intersect, options);
		targets.forEach(target => observer.observe(target)); // 複数対象をループで監視
	}

	function intersect(entries) {
		entries.forEach(entry => {
			if (entry.isIntersecting && isFixed) {
				isFixed = false;
				pageLink.classList.remove('fix');
				wrapper.style.height = '';
			} else if (!entry.isIntersecting && !isFixed) {
				isFixed = true;
				const pageLinkHeight = pageLink.offsetHeight;
				wrapper.style.height = pageLinkHeight + 'px';
				pageLink.classList.add('fix');
				caseLinkTop.classList.add('fix');
			}
		});
	}

	createObserver();

	let resizeTimer = null;
	window.addEventListener('resize', () => {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(() => {
			createObserver();
		}, 200);
	});
}

io();


jQuery(function ($) {
	$(function () {
		$(".specification__more").on("click", function () {
			$(this).toggleClass("show");
			$(this).prev(".specification__list").toggleClass("show");
		});

		$(".movieColumn__more").on("click", function () {
			$(this).toggleClass("show");
			$(this).prev(".movieColumn__list").toggleClass("show");
		});

		$(".qa__item").on("click", function () {
			$(this).toggleClass("show");
			$(this).children(".qa__question,.qa__answer").toggleClass("show");
		});

		// $('.faq__tabItem').on('click', function () {
		// 	var index = $(this).index();

		// 	// タブのactiveを切り替え
		// 	$('.faq__tabItem').removeClass('active');
		// 	$(this).addClass('active');

		// 	// 同じインデックスのqa__listを表示
		// 	$('.qa__list').removeClass('active');
		// 	$('.qa__list').eq(index).addClass('active');
		// });


		const recommendswiper = new Swiper(".recommend__sliderArea", {
			loop: true, // ループさせる
			speed: 500, // 少しゆっくり(デフォルトは300)
			slidesPerView: 1,
			spaceBetween: 10,
			breakpoints: {
				480: {
					slidesPerView: 'auto',
					// slidesPerView: 3,
					spaceBetween: 32,
				}
			},
			navigation: {
				nextEl: ".recommend__button--next",
				prevEl: ".recommend__button--prev",
			},
		});

	});
});